module.exports = __webpack_public_path__ + "img/djifly_2.8793db31.jpg";